/**
 * Sorts variant values with a combination of alphabetical and numerical sorting
 * First sorts by non-numeric characters, then by the first number found in each string
 *
 * @param values - Array of variant values to sort
 * @returns Sorted array of variant values
 *
 * Example:
 * Input: ['100ml', '10ml', '200ml', '20ml']
 * Output: ['10ml', '20ml', '100ml', '200ml']
 * Input: ['5 / 40 mg', '10 / 80 mg', '2.5 / 20 mg']
 * Output: ['2.5 / 20 mg', '5 / 40 mg', '10 / 80 mg']
 * Input: [ 'Lamm', 'Hirsch','Entenhälse', 'Pferd', 'Hunde', 'Katze' ]
 * Output: ['Entenhälse', 'Hirsch', 'Hunde', 'Katze', 'Lamm', 'Pferd']
 */
export const sortVariants = (values: string[]): string[] => {
  return values?.sort((a, b) => {
    const sortedByChars = a.replace(/[\d.,]/g, '').localeCompare(b.replace(/[\d.,]/g, ''))
    if (sortedByChars !== 0)
      return sortedByChars
    return Number.parseInt(
      a.replace(/[^\d.,]*([\d.,]+)[^\d.,]*/, '$1'),
    ) - Number.parseInt(b.replace(/[^\d.,]*([\d.,]+)[^\d.,]*/, '$1'))
  })
}
